// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Numeral from "numeral";
import * as Belt_Map from "rescript/lib/es6/belt_Map.js";
import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Tabs from "@reach/tabs";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactFeather from "react-feather";
import * as Hooks$Coronate from "../Hooks.res.js";
import * as Utils$Coronate from "../Utils.res.js";
import * as Data_Id$Coronate from "../Data/Data_Id.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Data_Player$Coronate from "../Data/Data_Player.res.js";
import * as HelpDialogs$Coronate from "../HelpDialogs.res.js";
import * as Data_Scoring$Coronate from "../Data/Data_Scoring.res.js";
import * as HtmlEntities$Coronate from "../HtmlEntities.res.js";
import VisuallyHidden from "@reach/visually-hidden";

function PageTourneyScores$ScoreTable(props) {
  var tourney = props.tourney;
  var tieBreaks = tourney.tieBreaks;
  var getPlayer = props.getPlayer;
  var size = props.size;
  var standingTree = Data_Scoring$Coronate.createStandingTree(Belt_Array.keep(Data_Scoring$Coronate.createStandingArray(Data_Scoring$Coronate.fromTournament(tourney.roundList, tourney.scoreAdjustments), tieBreaks), (function (param) {
              return !Data_Id$Coronate.isDummy(param.id);
            })), tieBreaks);
  var tmp;
  tmp = size === "Compact" ? "title-30" : "title-40";
  var tmp$1;
  tmp$1 = size === "Compact" ? null : Belt_Array.map(tieBreaks, (function (tb) {
            return JsxRuntime.jsx("th", {
                        children: Data_Scoring$Coronate.TieBreak.toPrettyString(tb),
                        className: "title-10",
                        scope: "col"
                      }, Data_Scoring$Coronate.TieBreak.toString(tb));
          }));
  return JsxRuntime.jsxs("table", {
              children: [
                JsxRuntime.jsx("caption", {
                      children: props.title,
                      className: tmp
                    }),
                JsxRuntime.jsx("thead", {
                      children: JsxRuntime.jsxs("tr", {
                            children: [
                              JsxRuntime.jsx("th", {
                                    children: "Rank",
                                    className: "title-10",
                                    scope: "col"
                                  }),
                              JsxRuntime.jsx("th", {
                                    children: "Name",
                                    className: "title-10",
                                    scope: "col"
                                  }),
                              JsxRuntime.jsx("th", {
                                    children: "Score",
                                    className: "title-10",
                                    scope: "col"
                                  }),
                              tmp$1
                            ],
                            className: "pagescores__topheader"
                          })
                    }),
                JsxRuntime.jsx("tbody", {
                      children: Belt_Array.mapWithIndex(Belt_Array.reverse(Belt_List.toArray(standingTree)), (function (rank, standingsFlat) {
                              return Belt_Array.mapWithIndex(Belt_Array.reverse(Belt_List.toArray(standingsFlat)), (function (i, standing) {
                                            var tmp;
                                            tmp = size === "Compact" ? JsxRuntime.jsx("td", {
                                                    children: Data_Player$Coronate.fullName(getPlayer(standing.id)),
                                                    className: "pagescores__row-td pagescores__playername"
                                                  }) : JsxRuntime.jsx(Utils$Coronate.TestId.make, {
                                                    children: JsxRuntime.jsx("th", {
                                                          children: Data_Player$Coronate.fullName(getPlayer(standing.id)),
                                                          className: "pagescores__row-th pagescores__playername",
                                                          scope: "row"
                                                        }),
                                                    testId: "rank-" + (String(rank + 1 | 0) + ("." + String(i)))
                                                  });
                                            var tmp$1;
                                            tmp$1 = size === "Compact" ? null : Belt_Array.map(tieBreaks, (function (tb) {
                                                      return JsxRuntime.jsx("td", {
                                                                  children: Data_Scoring$Coronate.Score.Sum.toNumeral(Data_Scoring$Coronate.getTieBreak(standing, tb)).format("1/2"),
                                                                  className: "pagescores__row-td table__number"
                                                                }, Data_Scoring$Coronate.TieBreak.toString(tb));
                                                    }));
                                            return JsxRuntime.jsxs("tr", {
                                                        children: [
                                                          i === 0 ? JsxRuntime.jsx("th", {
                                                                  children: rank + 1 | 0,
                                                                  className: "table__number pagescores__number pagescores__rank pagescores__row-th",
                                                                  rowSpan: Belt_List.size(standingsFlat),
                                                                  scope: "row"
                                                                }) : null,
                                                          tmp,
                                                          JsxRuntime.jsx("td", {
                                                                children: Data_Scoring$Coronate.Score.Sum.toNumeral(standing.score).format("1/2"),
                                                                className: "pagescores__number pagescores__row-td table__number"
                                                              }),
                                                          tmp$1
                                                        ],
                                                        className: "pagescores__row"
                                                      }, Data_Id$Coronate.toString(standing.id));
                                          }));
                            }))
                    })
              ],
              className: "pagescores__table"
            });
}

var ScoreTable = {
  make: PageTourneyScores$ScoreTable
};

function PageTourneyScores$SelectTieBreaks(props) {
  var tourney = props.tourney;
  var tieBreaks = tourney.tieBreaks;
  var setTourney = props.setTourney;
  var match = React.useState(function () {
        
      });
  var setSelectedTb = match[1];
  var selectedTb = match[0];
  var defaultId = function (x) {
    if (x !== undefined) {
      return x;
    } else if (selectedTb !== undefined) {
      return selectedTb;
    } else {
      return "Median";
    }
  };
  var toggleTb = function (id) {
    if (tieBreaks.includes(defaultId(id))) {
      setTourney({
            id: tourney.id,
            name: tourney.name,
            date: tourney.date,
            playerIds: tourney.playerIds,
            scoreAdjustments: tourney.scoreAdjustments,
            byeQueue: tourney.byeQueue,
            tieBreaks: tourney.tieBreaks.filter(function (tbId) {
                  return defaultId(id) !== tbId;
                }),
            roundList: tourney.roundList
          });
      return setSelectedTb(function (param) {
                  
                });
    } else {
      return setTourney({
                  id: tourney.id,
                  name: tourney.name,
                  date: tourney.date,
                  playerIds: tourney.playerIds,
                  scoreAdjustments: tourney.scoreAdjustments,
                  byeQueue: tourney.byeQueue,
                  tieBreaks: Js_array.concat(tourney.tieBreaks, [defaultId(id)]),
                  roundList: tourney.roundList
                });
    }
  };
  var moveTb = function (direction) {
    if (selectedTb === undefined) {
      return ;
    }
    var index = tieBreaks.indexOf(selectedTb);
    setTourney({
          id: tourney.id,
          name: tourney.name,
          date: tourney.date,
          playerIds: tourney.playerIds,
          scoreAdjustments: tourney.scoreAdjustments,
          byeQueue: tourney.byeQueue,
          tieBreaks: Utils$Coronate.$$Array.swap(tourney.tieBreaks, index, index + direction | 0),
          roundList: tourney.roundList
        });
  };
  return JsxRuntime.jsxs(Utils$Coronate.PanelContainer.make, {
              children: [
                JsxRuntime.jsxs(Utils$Coronate.Panel.make, {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("button", {
                                      children: "Remove",
                                      className: "button-micro",
                                      disabled: selectedTb === undefined,
                                      onClick: (function (param) {
                                          toggleTb(undefined);
                                        })
                                    }),
                                JsxRuntime.jsxs("button", {
                                      children: [
                                        JsxRuntime.jsx(ReactFeather.ArrowUp, {}),
                                        " Move up"
                                      ],
                                      className: "button-micro",
                                      disabled: selectedTb === undefined,
                                      onClick: (function (param) {
                                          moveTb(-1);
                                        })
                                    }),
                                JsxRuntime.jsxs("button", {
                                      children: [
                                        JsxRuntime.jsx(ReactFeather.ArrowDown, {}),
                                        " Move down"
                                      ],
                                      className: "button-micro",
                                      disabled: selectedTb === undefined,
                                      onClick: (function (param) {
                                          moveTb(1);
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: "Done",
                                      className: "button-micro " + (
                                        selectedTb !== undefined ? "button-primary" : ""
                                      ),
                                      disabled: selectedTb === undefined,
                                      onClick: (function (param) {
                                          setSelectedTb(function (param) {
                                                
                                              });
                                        })
                                    })
                              ],
                              className: "toolbar"
                            }),
                        JsxRuntime.jsxs("table", {
                              children: [
                                JsxRuntime.jsx("caption", {
                                      children: "Selected tiebreak methods",
                                      className: "title-30"
                                    }),
                                JsxRuntime.jsx("thead", {
                                      children: JsxRuntime.jsxs("tr", {
                                            children: [
                                              JsxRuntime.jsx("th", {
                                                    children: "Name"
                                                  }),
                                              JsxRuntime.jsx("th", {
                                                    children: JsxRuntime.jsx(VisuallyHidden, {
                                                          children: "Controls"
                                                        })
                                                  })
                                            ]
                                          })
                                    }),
                                JsxRuntime.jsx("tbody", {
                                      children: Belt_Array.map(tieBreaks, (function (tieBreak) {
                                              return JsxRuntime.jsxs("tr", {
                                                          children: [
                                                            JsxRuntime.jsx("td", {
                                                                  children: Data_Scoring$Coronate.TieBreak.toPrettyString(tieBreak)
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsx("button", {
                                                                        children: selectedTb !== undefined && selectedTb === tieBreak ? "Done" : "Edit",
                                                                        className: "button-micro",
                                                                        disabled: selectedTb !== undefined && selectedTb !== tieBreak,
                                                                        onClick: (function (param) {
                                                                            if (selectedTb !== undefined) {
                                                                              if (selectedTb === tieBreak) {
                                                                                return setSelectedTb(function (param) {
                                                                                            
                                                                                          });
                                                                              } else {
                                                                                return setSelectedTb(function (param) {
                                                                                            return tieBreak;
                                                                                          });
                                                                              }
                                                                            } else {
                                                                              return setSelectedTb(function (param) {
                                                                                          return tieBreak;
                                                                                        });
                                                                            }
                                                                          })
                                                                      }),
                                                                  style: {
                                                                    width: "48px"
                                                                  }
                                                                })
                                                          ],
                                                          className: Belt_Option.mapWithDefault(selectedTb, "", (function (x) {
                                                                  if (x === tieBreak) {
                                                                    return "selected";
                                                                  } else {
                                                                    return "";
                                                                  }
                                                                }))
                                                        }, Data_Scoring$Coronate.TieBreak.toString(tieBreak));
                                            })),
                                      className: "content"
                                    })
                              ]
                            })
                      ]
                    }),
                JsxRuntime.jsxs(Utils$Coronate.Panel.make, {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: HtmlEntities$Coronate.nbsp,
                              className: "toolbar"
                            }),
                        JsxRuntime.jsxs("table", {
                              children: [
                                JsxRuntime.jsx("caption", {
                                      children: "Available tiebreak methods",
                                      className: "title-30"
                                    }),
                                JsxRuntime.jsx("thead", {
                                      children: JsxRuntime.jsxs("tr", {
                                            children: [
                                              JsxRuntime.jsx("th", {
                                                    children: "Name"
                                                  }),
                                              JsxRuntime.jsx("th", {
                                                    children: JsxRuntime.jsx(VisuallyHidden, {
                                                          children: "Controls"
                                                        })
                                                  })
                                            ]
                                          })
                                    }),
                                JsxRuntime.jsx("tbody", {
                                      children: Belt_Array.map([
                                            "Median",
                                            "Solkoff",
                                            "Cumulative",
                                            "CumulativeOfOpposition",
                                            "MostBlack"
                                          ], (function (tieBreak) {
                                              return JsxRuntime.jsxs("tr", {
                                                          children: [
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsx("span", {
                                                                        children: Data_Scoring$Coronate.TieBreak.toPrettyString(tieBreak),
                                                                        className: tieBreaks.includes(tieBreak) ? "disabled" : "enabled"
                                                                      })
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: tieBreaks.includes(tieBreak) ? null : JsxRuntime.jsx("button", {
                                                                          children: "Add",
                                                                          className: "button-micro",
                                                                          onClick: (function (param) {
                                                                              toggleTb(tieBreak);
                                                                            })
                                                                        })
                                                                })
                                                          ]
                                                        }, Data_Scoring$Coronate.TieBreak.toString(tieBreak));
                                            })),
                                      className: "content"
                                    })
                              ],
                              style: {
                                marginTop: "16px"
                              }
                            })
                      ]
                    })
              ],
              className: "content-area"
            });
}

function PageTourneyScores(props) {
  var tournament = props.tournament;
  var tourney = tournament.tourney;
  var helpDialog = Hooks$Coronate.useBool(false);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs(Tabs.Tabs, {
                      children: [
                        JsxRuntime.jsxs(Tabs.TabList, {
                              children: [
                                JsxRuntime.jsxs(Tabs.Tab, {
                                      children: [
                                        JsxRuntime.jsx(ReactFeather.List, {}),
                                        " Scores"
                                      ]
                                    }),
                                JsxRuntime.jsxs(Tabs.Tab, {
                                      children: [
                                        JsxRuntime.jsx(ReactFeather.Settings, {}),
                                        " Edit tiebreak rules"
                                      ]
                                    })
                              ]
                            }),
                        JsxRuntime.jsxs(Tabs.TabPanels, {
                              children: [
                                JsxRuntime.jsx(Tabs.TabPanel, {
                                      children: JsxRuntime.jsx(PageTourneyScores$ScoreTable, {
                                            size: "Expanded",
                                            tourney: tourney,
                                            getPlayer: tournament.getPlayer,
                                            title: "Score detail"
                                          })
                                    }),
                                JsxRuntime.jsx(Tabs.TabPanel, {
                                      children: JsxRuntime.jsx(PageTourneyScores$SelectTieBreaks, {
                                            tourney: tourney,
                                            setTourney: tournament.setTourney
                                          })
                                    })
                              ]
                            })
                      ]
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("button", {
                            children: [
                              JsxRuntime.jsx(ReactFeather.HelpCircle, {}),
                              " Tiebreak method information"
                            ],
                            onClick: (function (param) {
                                helpDialog.setTrue();
                              })
                          }),
                      className: "toolbar"
                    }),
                JsxRuntime.jsx(HelpDialogs$Coronate.TieBreaks.make, {
                      state: helpDialog,
                      ariaLabel: "Tiebreak method information"
                    })
              ]
            });
}

function getXScore(scoreData, player1Id, player2Id) {
  if (Data_Id$Coronate.eq(player1Id, player2Id)) {
    return JsxRuntime.jsx(ReactFeather.X, {
                className: "pagescores__x"
              });
  }
  var scoreData$1 = Belt_Map.get(scoreData, player1Id);
  if (scoreData$1 === undefined) {
    return null;
  }
  var result = Data_Scoring$Coronate.oppResultsToSumById(scoreData$1, player2Id);
  if (result !== undefined) {
    return Data_Scoring$Coronate.Score.Sum.toNumeral(Caml_option.valFromOption(result)).format("1/2");
  } else {
    return null;
  }
}

function getRatingChangeTds(scoreData, playerId) {
  var firstRating = Belt_Option.getWithDefault(Belt_Option.map(Belt_Map.get(scoreData, playerId), (function (x) {
              return x.firstRating;
            })), 0);
  var lastRating = Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Map.get(scoreData, playerId), (function (x) {
              return Belt_List.head(x.ratings);
            })), firstRating);
  var change = Numeral(lastRating - firstRating | 0).format("+0");
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("td", {
                      children: lastRating,
                      className: "pagescores__row-td table__number"
                    }),
                JsxRuntime.jsx("td", {
                      children: change,
                      className: "pagescores__row-td table__number body-10"
                    })
              ]
            });
}

function PageTourneyScores$Crosstable(props) {
  var match = props.tournament;
  var match$1 = match.tourney;
  var getPlayer = match.getPlayer;
  var scoreData = Data_Scoring$Coronate.fromTournament(match$1.roundList, match$1.scoreAdjustments);
  var standings = Data_Scoring$Coronate.createStandingArray(scoreData, match$1.tieBreaks);
  return JsxRuntime.jsxs("table", {
              children: [
                JsxRuntime.jsx("caption", {
                      children: "Crosstable"
                    }),
                JsxRuntime.jsx("thead", {
                      children: JsxRuntime.jsxs("tr", {
                            children: [
                              JsxRuntime.jsx("th", {
                                    children: "#"
                                  }),
                              JsxRuntime.jsx("th", {
                                    children: "Name"
                                  }),
                              Belt_Array.mapWithIndex(standings, (function (rank, param) {
                                      return JsxRuntime.jsx("th", {
                                                  children: rank + 1 | 0
                                                }, String(rank));
                                    })),
                              JsxRuntime.jsx("th", {
                                    children: "Score"
                                  }),
                              JsxRuntime.jsx("th", {
                                    children: "Rating",
                                    colSpan: 2
                                  })
                            ]
                          })
                    }),
                JsxRuntime.jsx("tbody", {
                      children: Belt_Array.mapWithIndex(standings, (function (index, standing) {
                              return JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("th", {
                                                  children: index + 1 | 0,
                                                  className: "pagescores__row-th pagescores__rank",
                                                  scope: "col"
                                                }),
                                            JsxRuntime.jsx("th", {
                                                  children: Data_Player$Coronate.fullName(getPlayer(standing.id)),
                                                  className: "pagescores__row-th pagescores__playername",
                                                  scope: "row"
                                                }),
                                            Belt_Array.mapWithIndex(standings, (function (index2, opponent) {
                                                    return JsxRuntime.jsx("td", {
                                                                children: getXScore(scoreData, standing.id, opponent.id),
                                                                className: "pagescores__row-td table__number"
                                                              }, String(index2));
                                                  })),
                                            JsxRuntime.jsx("td", {
                                                  children: Data_Scoring$Coronate.Score.Sum.toNumeral(standing.score).format("1/2"),
                                                  className: "pagescores__row-td table__number"
                                                }),
                                            getRatingChangeTds(scoreData, standing.id)
                                          ],
                                          className: "pagescores__row"
                                        }, String(index));
                            }))
                    })
              ],
              className: "pagescores__table"
            });
}

var make = PageTourneyScores;

var Crosstable = {
  make: PageTourneyScores$Crosstable
};

export {
  make ,
  ScoreTable ,
  Crosstable ,
}
/* react Not a pure module */
